import React from 'react';
import { ConfigContext } from './contexts';

import { ComponentSettings } from './types';
import { GlobalStateProvider } from './providers/GlobalStateProvider';
import CustomerDetailsContainer from './containers/CustomerDetailsContainer';

const App = ({ customerProfile }: ComponentSettings) => {
  return (
    <ConfigContext.Provider value={{ customerProfile }}>
      <GlobalStateProvider>
        <CustomerDetailsContainer />
      </GlobalStateProvider>
    </ConfigContext.Provider>
  );
};

export default App;
